import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { RedocStandalone } from 'redoc';
// import Loading from './Loading';
import { Alert } from 'react-bootstrap';
import config from '../config';
import ReactGA from 'react-ga';

const APIRedoc = () => {

  // removed custom loading to avoid unnecessary rerender (until solution is found)
  // const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);

  const onLoaded = (err) => {
    if (err) setErrorMessage('Error loading API documentation, please try again later.');
    // setIsLoading(false);

    const redocOutboundLinks = document.getElementsByTagName('outboundlink');
    for (let i = 0; i < redocOutboundLinks.length; i++) {
      const node = redocOutboundLinks[i];
      ReactDOM.render(createOutboundLink(node), node);
    };
  }

  const createOutboundLink = (node) => {
    const label = node.getAttribute('label') || node.getAttribute('href');
    return (
      <ReactGA.OutboundLink key={label} eventLabel={label} to={node.getAttribute('href')} target="_blank">
        {node.textContent}
      </ReactGA.OutboundLink>
    )
  }

  return (
    <>
      {/* <Loading show={isLoading} /> */}
      <div className="centered-page">
        {errorMessage ?
          <Alert variant="danger">{errorMessage}</Alert>
          :
          <RedocStandalone
            specUrl={config.consolidatedOasUrl}
            options={{
              hideDownloadButton: false,
              // hideLoading: true,
              suppressWarnings: (config.env === 'prd'),
              theme: {
                colors: {
                  primary: {
                    main: '#0F567F'
                  },
                },
                sidebar: {
                  backgroundColor: '#F7FBF9'
                },
              },
            }}
            onLoaded={onLoaded}
          />

        }
      </div>
    </>
  );
}

export default APIRedoc;
